import * as Yup from 'yup'
import _ from 'lodash'



export const ASSET_LABELS = {
    CREATE_ASSET: "Add Asset",
    EDIT_ASSET: "Edit Asset"
};
export const ASSET_TYPES = {
    DOCUMENT: 'Document',
    IMAGE: 'Image',
    EXCEL_SHEET: 'Excel Sheet',
    LINK: 'Link (URL)',
    SLIDE: 'Slide',
    TEXT: 'Text',
    VIDEO: 'Video'
}
// Add this mapping object
export const ASSET_TYPE_MAPPING = {
    'Text': 1,
    'Document': 2,  
    'Excel Sheet': 8,
    'Link (URL)': 4,
    'Slide': 5,
    'Video': 6,
    'Image': 7,
};

// Reverse mapping for API responses
export const ASSET_TYPE_REVERSE_MAPPING = {
    1: 'Text',
    2: 'Document',
    3: 'Document',
    4: 'Link (URL)',
    5: 'Slide',
    6: 'Video',
    7: 'Image',
    8: 'Excel Sheet',
};

 export const assetValidationSchema = Yup.object().shape({
        title: Yup.string()
            .required('Asset title is required'),

        description: Yup.string(),

        task_type: Yup.string()
            .required('Asset type is required'),


     asset_link: Yup.string()
         .nullable() // Allow null values
         .transform((curr, orig) => orig === '' ? null : curr) // Transform empty string to null
         .when('task_type', {
             is: ASSET_TYPE_MAPPING['Link (URL)'], // Compare against the NUMBER value, not string
             then: (schema) => schema
                 .required('URL is required for Link assets')
                 .url('Please enter a valid URL'),
             otherwise: (schema) => schema.notRequired() 
         }),

    })

